const actions = {
  async inviteUserToSpaceHandler({getters,dispatch},[user, userInAnotherSpace = false, userWasPinned = false]) {
    let ifInHub = getters.getIfCurrentUsersRoomIsHub
    await dispatch('analytics/inviteToRoom', [user, userInAnotherSpace, userWasPinned]) //do before so dispatch gets whether in hub before create space

    let roomId;
    if(ifInHub) {
      //create room before inviting user to the room
      let res = await dispatch('createSpaceHandler', [`${getters['current_user/fullName']}'s Room`, "", 1, 1]);
      if(res.success) roomId = res.success.id;
    }
    else roomId = getters.getCurrentUsersRoomId

    let res = await dispatch('api/nav/roomInvite',[user.userId, roomId])
    if(res.error) {
      // error inviting user to room message
      dispatch('showErrorInviteFailedPopup')
    }
  },
  async inviteUserToJumpSpaceHandler({getters,dispatch},[user, space]) { //if the user is in a jump space
    //this will move you to the jump space before inviting the user to your room
    //if you are in a room in the current area, you will need to leave first
    let ifInHub = getters.getIfCurrentUsersRoomIsHub
    await dispatch('analytics/inviteToJumpSpace', ['Clicked', user, space]) //do before so dispatch gets whether in hub before create space

    const callback = async () => {
      let roomId
      //switch to jump space
      let switchSpace = await dispatch('handleEnterSpacePortal', space.location.id)
      if(switchSpace?.success) {
        //create room in switch space before inviting user to the room
        let res = await dispatch('createSpaceHandler', [`${getters['current_user/fullName']}'s Room`, "", 1, 1]);
        if(res.success) roomId = res.success.id;
      }
      else return dispatch('showErrorInviteFailedPopup')

      let res = await dispatch('api/nav/roomInvite',[user.userId, roomId])
      if(res?.success) await dispatch('analytics/inviteToJumpSpace', ['Completed', user, space])
      if(res.error) {
        // error inviting user to space message
        dispatch('showErrorInviteFailedPopup')
      }
    }

    //show popup to notify the user they will need to leave their room/space
    let data = {
      title: ifInHub ? `You will be moved to ${space.name} to invite this user.` : `You will leave this room <br> and be moved to ${space.name} to invite this user.`,
      message: 'Are you sure you want to do this?',
      submitForm: async () => {
        if(!ifInHub) await dispatch('handleLeaveRoom')
        callback()
      }
    }
    dispatch('popups/notifications/confirmJumpSpaceInvite', data)
  },
};

export default {
  actions
};
